import { switchAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(switchAnatomy.keys);

const baseStyle = definePartsStyle({
  thumb: {
    bg: '#FFFFFF',
  },
  track: {
    bg: '#CFD0D8',
    _checked: {
      bg: '#4285F4',
    },
  },
});

export const switchTheme = defineMultiStyleConfig({ baseStyle });
